import {createStore, applyMiddleware, compose, Store, Middleware, Action} from 'redux'
import { routerMiddleware } from 'react-router-redux'
import { History } from 'history'
import { reducers, StoreState } from '../reducers'
import createSagaMiddleware from 'redux-saga'
import { rootSagas } from '../sagas'
import { loadState, saveState } from '../utils/localStorage'
import throttle from 'lodash.throttle'

const STORE_NAME = '##GO_TRASHY_WEB_CLIENT_STORE##'

export function configureStore(history: History): Store<StoreState> {
    const sagaMiddleware = createSagaMiddleware()
    const { __REDUX_DEVTOOLS_EXTENSION_COMPOSE__: devToolsCompose } = window
    const composeEnhancers = devToolsCompose || compose
    const persistedState = loadState(STORE_NAME)
    const store = createStore<StoreState>(
        reducers,
        persistedState,
        composeEnhancers(
            applyMiddleware(
                sagaMiddleware,
                routerMiddleware(history),
                Logger
            )
        )
    )
    store.subscribe(throttle(() => {
        saveState(STORE_NAME, store.getState())
    }, 1000))
    sagaMiddleware.run(rootSagas)

    if (module.hot) {
        module.hot.accept(() => {
            store.replaceReducer(require('../reducers').reducers)
        })
    }
    return store
}

const LAST_REDUX_ACTIONS_MAX_COUNT = 10;
export const lastReduxActions: Action[] = [];
const Logger: Middleware = api => next => action => {

    lastReduxActions.push(action);
    if(lastReduxActions.length >= LAST_REDUX_ACTIONS_MAX_COUNT)
        lastReduxActions.shift();

    return next(action)
}



// WEBPACK FOOTER //
// ./src/store/configureStore.ts